// import React, { useState, useEffect } from "react";
// import { ChevronDown, ChevronRight } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import logo from "../Images/ACTIGEN.jpg";
// import config from "./Config/config";

// const COLORS = {
//   green: "#5D694C",
//   green2: "#A8AFA0",
//   white: "#FAFAFA",
// };

// const FONTS = {
//   heading: "font-plus-jakarta-sans font-bold tracking-tight",
//   subheading: "font-plus-jakarta-sans font-semibold",
//   body: "font-plus-jakarta-sans font-normal",
//   button: "font-plus-jakarta-sans font-medium",
// };

// const WelcomeMessage = () => {
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [batches, setBatches] = useState([]);
//   const [selectedBatch, setSelectedBatch] = useState("");
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isLoadingBatches, setIsLoadingBatches] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     setTimeout(() => {
//       setIsLoaded(true);
//     }, 100);

//     fetchBatches();
//   }, []);

//   const fetchBatches = async () => {
//     try {
//       setIsLoadingBatches(true);
      
//       const response = await fetch(
//         `${config.API_BASE_URL}/api/batch_viewer/list_batches/`
//       );
      
//       if (response.ok) {
//         const data = await response.json();
//         console.log("Batches Response:", data);
        
//         // Extract batch names
//         const batchNames = data.batches || [];
        
//         setBatches(batchNames);
        
//         // Set first batch as default if available
//         if (batchNames.length > 0) {
//           setSelectedBatch(batchNames[0]);
//         }
//       } else {
//         console.error("Failed to fetch batches:", response.status);
//         const errorText = await response.text();
//         console.error("Error details:", errorText);
//       }
//     } catch (error) {
//       console.error("Error fetching batches:", error);
//     } finally {
//       setIsLoadingBatches(false);
//     }
//   };

//   const handleShowBatch = () => {
//     if (selectedBatch) {
//       navigate(`/batch/${encodeURIComponent(selectedBatch)}`);
//     }
//   };

//   return (
//     <div
//       className="flex min-h-screen relative"
//       style={{ backgroundColor: COLORS.white }}
//     >
//       <main className="flex-1 transition-all duration-300 z-10 w-full">
//         <div className="flex flex-col p-8 min-h-screen justify-center items-center">
//           {/* Hero Content */}
//           <div className="text-center max-w-2xl mb-12">
//             <div
//               className={`transition-all duration-700 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100"
//                   : "translate-y-10 opacity-0"
//               }`}
//             >
//               <span
//                 className={`${FONTS.button} inline-block px-3 py-1 rounded-full text-sm font-medium mb-4`}
//                 style={{ backgroundColor: COLORS.green2, color: "black" }}
//               >
//                 Innovative AI Solutions
//               </span>
//               <h1
//                 className={`${FONTS.heading} text-4xl md:text-6xl mb-6 leading-tight`}
//                 style={{ color: COLORS.green }}
//               >
//                  Image Viewer
//               </h1>
//               <p
//                 className={`${FONTS.body} text-xl mb-8 mx-auto leading-relaxed`}
//                 style={{ color: COLORS.green }}
//               >
//                 Select a batch to begin viewing your document collection
//               </p>
//             </div>
//           </div>

//           {/* Batch Selection Card */}
//           <div className="w-full max-w-2xl">
//             <div
//               className={`relative z-10 transition-all duration-1000 delay-500 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100 rotate-0"
//                   : "translate-y-20 opacity-0 rotate-3"
//               }`}
//             >
//               <div
//                 className="rounded-2xl shadow-xl p-8 border overflow-hidden relative"
//                 style={{
//                   backgroundColor: COLORS.white,
//                   borderColor: COLORS.green2,
//                   boxShadow: `0 20px 25px -5px ${COLORS.green2}30, 0 10px 10px -5px ${COLORS.green2}20`,
//                 }}
//               >
//                 <h2
//                   className={`${FONTS.subheading} text-2xl font-bold mb-6 text-center`}
//                   style={{ color: COLORS.green }}
//                 >
//                   Batch Selection
//                 </h2>

//                 <div className="space-y-6">
//                   <div>
//                     <label
//                       className={`${FONTS.body} block mb-3 text-sm font-medium`}
//                       style={{ color: COLORS.green }}
//                     >
//                       Select a batch to view
//                     </label>

//                     {/* Custom Dropdown */}
//                     <div className="relative">
//                       <button
//                         onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//                         disabled={isLoadingBatches}
//                         className={`${FONTS.body} w-full px-4 py-4 text-left rounded-lg border flex items-center justify-between transition-all duration-300 ${
//                           isLoadingBatches ? "opacity-50 cursor-not-allowed" : ""
//                         }`}
//                         style={{
//                           borderColor: COLORS.green2,
//                           backgroundColor: COLORS.white,
//                           color: COLORS.green,
//                         }}
//                         onMouseOver={(e) => {
//                           if (!isLoadingBatches) {
//                             e.currentTarget.style.borderColor = COLORS.green;
//                             e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.green2}40`;
//                           }
//                         }}
//                         onMouseOut={(e) => {
//                           e.currentTarget.style.borderColor = COLORS.green2;
//                           e.currentTarget.style.boxShadow = "none";
//                         }}
//                       >
//                         <span>
//                           {isLoadingBatches
//                             ? "Loading batches..."
//                             : selectedBatch || "Choose a batch..."}
//                         </span>
//                         <ChevronDown
//                           className={`w-5 h-5 transition-transform duration-300 ${
//                             isDropdownOpen ? "rotate-180" : ""
//                           }`}
//                         />
//                       </button>

//                       {/* Dropdown Menu */}
//                       {isDropdownOpen && !isLoadingBatches && (
//                         <div
//                           className="absolute w-full mt-2 rounded-lg border shadow-lg z-20 max-h-60 overflow-y-auto"
//                           style={{
//                             backgroundColor: COLORS.white,
//                             borderColor: COLORS.green2,
//                           }}
//                         >
//                           {batches.length > 0 ? (
//                             batches.map((batch, index) => (
//                               <button
//                                 key={index}
//                                 onClick={() => {
//                                   setSelectedBatch(batch);
//                                   setIsDropdownOpen(false);
//                                 }}
//                                 className={`${FONTS.body} w-full px-4 py-3 text-left transition-all duration-200 ${
//                                   selectedBatch === batch
//                                     ? "font-semibold"
//                                     : ""
//                                 }`}
//                                 style={{
//                                   color: COLORS.green,
//                                   backgroundColor:
//                                     selectedBatch === batch
//                                       ? COLORS.green2 + "40"
//                                       : "transparent",
//                                 }}
//                                 onMouseOver={(e) => {
//                                   if (selectedBatch !== batch) {
//                                     e.currentTarget.style.backgroundColor =
//                                       COLORS.green2 + "20";
//                                   }
//                                 }}
//                                 onMouseOut={(e) => {
//                                   if (selectedBatch !== batch) {
//                                     e.currentTarget.style.backgroundColor =
//                                       "transparent";
//                                   } else {
//                                     e.currentTarget.style.backgroundColor =
//                                       COLORS.green2 + "40";
//                                   }
//                                 }}
//                               >
//                                 {batch}
//                               </button>
//                             ))
//                           ) : (
//                             <div
//                               className={`${FONTS.body} px-4 py-3 text-center`}
//                               style={{ color: COLORS.green }}
//                             >
//                               No batches available
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Show Batch Button */}
//                   <button
//                     onClick={handleShowBatch}
//                     disabled={!selectedBatch || isLoadingBatches}
//                     className={`${FONTS.button} w-full py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed`}
//                     style={{
//                       backgroundColor:
//                         selectedBatch && !isLoadingBatches
//                           ? COLORS.green
//                           : COLORS.green2,
//                       color: COLORS.white,
//                     }}
//                     onMouseOver={(e) => {
//                       if (selectedBatch && !isLoadingBatches) {
//                         e.currentTarget.style.transform = "translateY(-2px)";
//                         e.currentTarget.style.boxShadow = `0 10px 20px -5px ${COLORS.green}40`;
//                       }
//                     }}
//                     onMouseOut={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow = "none";
//                     }}
//                   >
//                     <span className="text-lg">Show Batch</span>
//                     <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
//                   </button>
//                 </div>

//                 {/* Info Text */}
//                 {selectedBatch && !isLoadingBatches && (
//                   <div
//                     className={`${FONTS.body} mt-6 p-4 rounded-lg text-sm text-center`}
//                     style={{
//                       backgroundColor: COLORS.green2 + "20",
//                       color: COLORS.green,
//                     }}
//                   >
//                     You have selected: <strong>{selectedBatch}</strong>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>


//       {/* Animation styles */}
//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s forwards;
//         }

//         h1,
//         h2,
//         h3 {
//           letter-spacing: -0.025em;
//         }

//         p {
//           letter-spacing: 0.015em;
//         }

//         .overflow-y-auto::-webkit-scrollbar {
//           width: 8px;
//         }

//         .overflow-y-auto::-webkit-scrollbar-track {
//           background: ${COLORS.green2}20;
//           border-radius: 4px;
//         }

//         .overflow-y-auto::-webkit-scrollbar-thumb {
//           background: ${COLORS.green2};
//           border-radius: 4px;
//         }

//         .overflow-y-auto::-webkit-scrollbar-thumb:hover {
//           background: ${COLORS.green};
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WelcomeMessage;



////////////////////////////added auth

// import React, { useState, useEffect } from "react";
// import { ChevronDown, ChevronRight } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import logo from "../Images/ACTIGEN.jpg";
// import config from "./Config/config";

// const COLORS = {
//   green: "#221b8dff",
//   green2: "#9aa390ff",
//   white: "#FAFAFA",
// };

// const FONTS = {
//   heading: "font-plus-jakarta-sans font-bold tracking-tight",
//   subheading: "font-plus-jakarta-sans font-semibold",
//   body: "font-plus-jakarta-sans font-normal",
//   button: "font-plus-jakarta-sans font-medium",
// };

// const WelcomeMessage = () => {
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [batches, setBatches] = useState([]);
//   const [selectedBatch, setSelectedBatch] = useState("");
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);
//   const [isLoadingBatches, setIsLoadingBatches] = useState(true);
//   const [error, setError] = useState(null);
  
//   const navigate = useNavigate();
//   const { getToken, isAuthenticated, logout } = useAuth();

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     setTimeout(() => {
//       setIsLoaded(true);
//     }, 100);

//     fetchBatches();
//   }, [isAuthenticated, navigate]);

//   const fetchBatches = async () => {
//     try {
//       setIsLoadingBatches(true);
//       setError(null);
      
//       const token = getToken();
      
//       const response = await fetch(
//         `${config.API_BASE_URL}/api/batch_viewer/list_batches/`,
//         {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       if (response.status === 401) {
//         // Token expired or invalid
//         logout();
//         navigate("/login");
//         return;
//       }
      
//       if (response.ok) {
//         const data = await response.json();
//         console.log("Batches Response:", data);
        
//         const batchNames = data.batches || [];
//         setBatches(batchNames);
        
//         if (batchNames.length > 0) {
//           setSelectedBatch(batchNames[0]);
//         }
//       } else {
//         console.error("Failed to fetch batches:", response.status);
//         const errorText = await response.text();
//         console.error("Error details:", errorText);
//         setError("Failed to load batches. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error fetching batches:", error);
//       setError("An error occurred while loading batches.");
//     } finally {
//       setIsLoadingBatches(false);
//     }
//   };

//   const handleShowBatch = () => {
//     if (selectedBatch) {
//       navigate(`/batch/${encodeURIComponent(selectedBatch)}`);
//     }
//   };

//   return (
//     <div
//       className="flex min-h-screen relative"
//       style={{ backgroundColor: COLORS.white }}
//     >
//       <main className="flex-1 transition-all duration-300 z-10 w-full">
//         <div className="flex flex-col p-8 min-h-screen justify-center items-center">
//           {/* Hero Content */}
//           <div className="text-center max-w-2xl mb-12">
//             <div
//               className={`transition-all duration-700 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100"
//                   : "translate-y-10 opacity-0"
//               }`}
//             >
//               <span
//                 className={`${FONTS.button} inline-block px-3 py-1 rounded-full text-sm font-medium mb-4`}
//                 style={{ backgroundColor: COLORS.green2, color: "black" }}
//               >
//                 Innovative AI Solutions
//               </span>
//               <h1
//                 className={`${FONTS.heading} text-4xl md:text-6xl mb-6 leading-tight`}
//                 style={{ color: COLORS.green }}
//               >
//                 Image Viewer
//               </h1>
//               <p
//                 className={`${FONTS.body} text-xl mb-8 mx-auto leading-relaxed`}
//                 style={{ color: COLORS.green }}
//               >
//                 Select a batch to begin viewing your document collection
//               </p>
//             </div>
//           </div>

//           {/* Batch Selection Card */}
//           <div className="w-full max-w-2xl">
//             <div
//               className={`relative z-10 transition-all duration-1000 delay-500 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100 rotate-0"
//                   : "translate-y-20 opacity-0 rotate-3"
//               }`}
//             >
//               <div
//                 className="rounded-2xl shadow-xl p-8 border overflow-hidden relative"
//                 style={{
//                   backgroundColor: COLORS.white,
//                   borderColor: COLORS.green2,
//                   boxShadow: `0 20px 25px -5px ${COLORS.green2}30, 0 10px 10px -5px ${COLORS.green2}20`,
//                 }}
//               >
//                 <h2
//                   className={`${FONTS.subheading} text-2xl font-bold mb-6 text-center`}
//                   style={{ color: COLORS.green }}
//                 >
//                   Batch Selection
//                 </h2>

//                 {error && (
//                   <div
//                     className="mb-4 p-3 rounded-lg text-sm text-center"
//                     style={{
//                       backgroundColor: "#FEE2E2",
//                       color: "#991B1B",
//                     }}
//                   >
//                     {error}
//                   </div>
//                 )}

//                 <div className="space-y-6">
//                   <div>
//                     <label
//                       className={`${FONTS.body} block mb-3 text-sm font-medium`}
//                       style={{ color: COLORS.green }}
//                     >
//                       Select a batch to view
//                     </label>

//                     {/* Custom Dropdown */}
//                     <div className="relative">
//                       <button
//                         onClick={() => setIsDropdownOpen(!isDropdownOpen)}
//                         disabled={isLoadingBatches}
//                         className={`${FONTS.body} w-full px-4 py-4 text-left rounded-lg border flex items-center justify-between transition-all duration-300 ${
//                           isLoadingBatches ? "opacity-50 cursor-not-allowed" : ""
//                         }`}
//                         style={{
//                           borderColor: COLORS.green2,
//                           backgroundColor: COLORS.white,
//                           color: COLORS.green,
//                         }}
//                         onMouseOver={(e) => {
//                           if (!isLoadingBatches) {
//                             e.currentTarget.style.borderColor = COLORS.green;
//                             e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.green2}40`;
//                           }
//                         }}
//                         onMouseOut={(e) => {
//                           e.currentTarget.style.borderColor = COLORS.green2;
//                           e.currentTarget.style.boxShadow = "none";
//                         }}
//                       >
//                         <span>
//                           {isLoadingBatches
//                             ? "Loading batches..."
//                             : selectedBatch || "Choose a batch..."}
//                         </span>
//                         <ChevronDown
//                           className={`w-5 h-5 transition-transform duration-300 ${
//                             isDropdownOpen ? "rotate-180" : ""
//                           }`}
//                         />
//                       </button>

//                       {/* Dropdown Menu */}
//                       {isDropdownOpen && !isLoadingBatches && (
//                         <div
//                           className="absolute w-full mt-2 rounded-lg border shadow-lg z-20 max-h-60 overflow-y-auto"
//                           style={{
//                             backgroundColor: COLORS.white,
//                             borderColor: COLORS.green2,
//                           }}
//                         >
//                           {batches.length > 0 ? (
//                             batches.map((batch, index) => (
//                               <button
//                                 key={index}
//                                 onClick={() => {
//                                   setSelectedBatch(batch);
//                                   setIsDropdownOpen(false);
//                                 }}
//                                 className={`${FONTS.body} w-full px-4 py-3 text-left transition-all duration-200 ${
//                                   selectedBatch === batch
//                                     ? "font-semibold"
//                                     : ""
//                                 }`}
//                                 style={{
//                                   color: COLORS.green,
//                                   backgroundColor:
//                                     selectedBatch === batch
//                                       ? COLORS.green2 + "40"
//                                       : "transparent",
//                                 }}
//                                 onMouseOver={(e) => {
//                                   if (selectedBatch !== batch) {
//                                     e.currentTarget.style.backgroundColor =
//                                       COLORS.green2 + "20";
//                                   }
//                                 }}
//                                 onMouseOut={(e) => {
//                                   if (selectedBatch !== batch) {
//                                     e.currentTarget.style.backgroundColor =
//                                       "transparent";
//                                   } else {
//                                     e.currentTarget.style.backgroundColor =
//                                       COLORS.green2 + "40";
//                                   }
//                                 }}
//                               >
//                                 {batch}
//                               </button>
//                             ))
//                           ) : (
//                             <div
//                               className={`${FONTS.body} px-4 py-3 text-center`}
//                               style={{ color: COLORS.green }}
//                             >
//                               No batches available
//                             </div>
//                           )}
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Show Batch Button */}
//                   <button
//                     onClick={handleShowBatch}
//                     disabled={!selectedBatch || isLoadingBatches}
//                     className={`${FONTS.button} w-full py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed`}
//                     style={{
//                       backgroundColor:
//                         selectedBatch && !isLoadingBatches
//                           ? COLORS.green
//                           : COLORS.green2,
//                       color: COLORS.white,
//                     }}
//                     onMouseOver={(e) => {
//                       if (selectedBatch && !isLoadingBatches) {
//                         e.currentTarget.style.transform = "translateY(-2px)";
//                         e.currentTarget.style.boxShadow = `0 10px 20px -5px ${COLORS.green}40`;
//                       }
//                     }}
//                     onMouseOut={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow = "none";
//                     }}
//                   >
//                     <span className="text-lg">Show Batch</span>
//                     <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
//                   </button>
//                 </div>

//                 {/* Info Text */}
//                 {selectedBatch && !isLoadingBatches && (
//                   <div
//                     className={`${FONTS.body} mt-6 p-4 rounded-lg text-sm text-center`}
//                     style={{
//                       backgroundColor: COLORS.green2 + "20",
//                       color: COLORS.green,
//                     }}
//                   >
//                     You have selected: <strong>{selectedBatch}</strong>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>

//       {/* Animation styles */}
//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s forwards;
//         }

//         h1,
//         h2,
//         h3 {
//           letter-spacing: -0.025em;
//         }

//         p {
//           letter-spacing: 0.015em;
//         }

//         .overflow-y-auto::-webkit-scrollbar {
//           width: 8px;
//         }

//         .overflow-y-auto::-webkit-scrollbar-track {
//           background: ${COLORS.green2}20;
//           border-radius: 4px;
//         }

//         .overflow-y-auto::-webkit-scrollbar-thumb {
//           background: ${COLORS.green2};
//           border-radius: 4px;
//         }

//         .overflow-y-auto::-webkit-scrollbar-thumb:hover {
//           background: ${COLORS.green};
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WelcomeMessage;



////////////////////search bar

// import React, { useState, useEffect } from "react";
// import { ChevronRight, Search, AlertCircle, CheckCircle } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import logo from "../Images/ACTIGEN.jpg";
// import config from "./Config/config";

// const COLORS = {
//   green: "#221b8dff",
//   green2: "#9aa390ff",
//   white: "#FAFAFA",
// };

// const FONTS = {
//   heading: "font-plus-jakarta-sans font-bold tracking-tight",
//   subheading: "font-plus-jakarta-sans font-semibold",
//   body: "font-plus-jakarta-sans font-normal",
//   button: "font-plus-jakarta-sans font-medium",
// };

// const WelcomeMessage = () => {
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [batchName, setBatchName] = useState("");
//   const [validationStatus, setValidationStatus] = useState(null); // null, 'validating', 'valid', 'invalid', 'no-images'
//   const [validationMessage, setValidationMessage] = useState("");
//   const [isValidating, setIsValidating] = useState(false);
//   const [error, setError] = useState(null);
  
//   const navigate = useNavigate();
//   const { getToken, isAuthenticated, logout } = useAuth();

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     setTimeout(() => {
//       setIsLoaded(true);
//     }, 100);
//   }, [isAuthenticated, navigate]);

//   // Debounced validation - only validate after user stops typing
//   useEffect(() => {
//     if (!batchName.trim()) {
//       setValidationStatus(null);
//       setValidationMessage("");
//       return;
//     }

//     const debounceTimer = setTimeout(() => {
//       validateBatch(batchName.trim());
//     }, 800); // Wait 800ms after user stops typing

//     return () => clearTimeout(debounceTimer);
//   }, [batchName]);

//   const validateBatch = async (batch) => {
//     try {
//       setIsValidating(true);
//       setValidationStatus('validating');
//       setValidationMessage("Checking batch...");
//       setError(null);
      
//       const token = getToken();
      
//       // First, check if batch exists by listing images
//       const response = await fetch(
//         `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batch)}`,
//         {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       if (response.status === 401) {
//         logout();
//         navigate("/login");
//         return;
//       }
      
//       if (response.ok) {
//         const data = await response.json();
//         console.log("Validation Response:", data);
        
//         if (data.images && data.images.length > 0) {
//           // Batch exists and has images
//           setValidationStatus('valid');
//           setValidationMessage(`✓ Batch found with ${data.total_count} image${data.total_count !== 1 ? 's' : ''}`);
//         } else {
//           // Batch exists but no images
//           setValidationStatus('no-images');
//           setValidationMessage("Batch exists but contains no images");
//         }
//       } else if (response.status === 404) {
//         // Batch doesn't exist
//         setValidationStatus('invalid');
//         setValidationMessage("Batch not found");
//       } else {
//         // Other error
//         console.error("Failed to validate batch:", response.status);
//         setValidationStatus('invalid');
//         setValidationMessage("Error validating batch");
//       }
//     } catch (error) {
//       console.error("Error validating batch:", error);
//       setValidationStatus('invalid');
//       setValidationMessage("Error connecting to server");
//     } finally {
//       setIsValidating(false);
//     }
//   };

//   const handleShowBatch = () => {
//     if (batchName.trim() && validationStatus === 'valid') {
//       navigate(`/batch/${encodeURIComponent(batchName.trim())}`);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && batchName.trim() && validationStatus === 'valid') {
//       handleShowBatch();
//     }
//   };

//   const getValidationColor = () => {
//     switch (validationStatus) {
//       case 'valid':
//         return '#10B981'; // Green
//       case 'invalid':
//       case 'no-images':
//         return '#EF4444'; // Red
//       case 'validating':
//         return '#F59E0B'; // Yellow/Orange
//       default:
//         return COLORS.green2;
//     }
//   };

//   const getValidationIcon = () => {
//     switch (validationStatus) {
//       case 'valid':
//         return <CheckCircle className="w-5 h-5 text-green-600" />;
//       case 'invalid':
//       case 'no-images':
//         return <AlertCircle className="w-5 h-5 text-red-600" />;
//       case 'validating':
//         return <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-yellow-600"></div>;
//       default:
//         return <Search className="w-5 h-5" style={{ color: COLORS.green2 }} />;
//     }
//   };

//   return (
//     <div
//       className="flex min-h-screen relative"
//       style={{ backgroundColor: COLORS.white }}
//     >
//       <main className="flex-1 transition-all duration-300 z-10 w-full">
//         <div className="flex flex-col p-8 min-h-screen justify-center items-center">
//           {/* Hero Content */}
//           <div className="text-center max-w-2xl mb-12">
//             <div
//               className={`transition-all duration-700 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100"
//                   : "translate-y-10 opacity-0"
//               }`}
//             >
//               <span
//                 className={`${FONTS.button} inline-block px-3 py-1 rounded-full text-sm font-medium mb-4`}
//                 style={{ backgroundColor: COLORS.green2, color: "black" }}
//               >
//                 Innovative AI Solutions
//               </span>
//               <h1
//                 className={`${FONTS.heading} text-4xl md:text-6xl mb-6 leading-tight`}
//                 style={{ color: COLORS.green }}
//               >
//                 Image Viewer
//               </h1>
//               <p
//                 className={`${FONTS.body} text-xl mb-8 mx-auto leading-relaxed`}
//                 style={{ color: COLORS.green }}
//               >
//                 Enter a batch name to begin viewing your document collection
//               </p>
//             </div>
//           </div>

//           {/* Batch Selection Card */}
//           <div className="w-full max-w-2xl">
//             <div
//               className={`relative z-10 transition-all duration-1000 delay-500 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100 rotate-0"
//                   : "translate-y-20 opacity-0 rotate-3"
//               }`}
//             >
//               <div
//                 className="rounded-2xl shadow-xl p-8 border overflow-hidden relative"
//                 style={{
//                   backgroundColor: COLORS.white,
//                   borderColor: COLORS.green2,
//                   boxShadow: `0 20px 25px -5px ${COLORS.green2}30, 0 10px 10px -5px ${COLORS.green2}20`,
//                 }}
//               >
//                 <h2
//                   className={`${FONTS.subheading} text-2xl font-bold mb-6 text-center`}
//                   style={{ color: COLORS.green }}
//                 >
//                   Batch Selection
//                 </h2>

//                 {error && (
//                   <div
//                     className="mb-4 p-3 rounded-lg text-sm text-center"
//                     style={{
//                       backgroundColor: "#FEE2E2",
//                       color: "#991B1B",
//                     }}
//                   >
//                     {error}
//                   </div>
//                 )}

//                 <div className="space-y-6">
//                   <div>
//                     <label
//                       className={`${FONTS.body} block mb-3 text-sm font-medium`}
//                       style={{ color: COLORS.green }}
//                     >
//                       Enter batch name
//                     </label>

//                     {/* Search Input */}
//                     <div className="relative">
//                       <input
//                         type="text"
//                         value={batchName}
//                         onChange={(e) => setBatchName(e.target.value)}
//                         onKeyPress={handleKeyPress}
//                         placeholder="Type batch name..."
//                         className={`${FONTS.body} w-full px-4 py-4 pr-12 rounded-lg border transition-all duration-300 focus:outline-none`}
//                         style={{
//                           borderColor: getValidationColor(),
//                           backgroundColor: COLORS.white,
//                           color: COLORS.green,
//                           boxShadow: validationStatus ? `0 0 0 3px ${getValidationColor()}20` : 'none',
//                         }}
//                       />
                      
//                       {/* Icon inside input */}
//                       <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
//                         {getValidationIcon()}
//                       </div>
//                     </div>

//                     {/* Validation Message */}
//                     {validationMessage && (
//                       <div
//                         className={`${FONTS.body} mt-2 p-3 rounded-lg text-sm transition-all duration-300`}
//                         style={{
//                           backgroundColor: `${getValidationColor()}15`,
//                           color: getValidationColor(),
//                           border: `1px solid ${getValidationColor()}30`,
//                         }}
//                       >
//                         {validationMessage}
//                       </div>
//                     )}
//                   </div>

//                   {/* Show Batch Button */}
//                   <button
//                     onClick={handleShowBatch}
//                     disabled={!batchName.trim() || validationStatus !== 'valid' || isValidating}
//                     className={`${FONTS.button} w-full py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed`}
//                     style={{
//                       backgroundColor:
//                         batchName.trim() && validationStatus === 'valid' && !isValidating
//                           ? COLORS.green
//                           : COLORS.green2,
//                       color: COLORS.white,
//                     }}
//                     onMouseOver={(e) => {
//                       if (batchName.trim() && validationStatus === 'valid' && !isValidating) {
//                         e.currentTarget.style.transform = "translateY(-2px)";
//                         e.currentTarget.style.boxShadow = `0 10px 20px -5px ${COLORS.green}40`;
//                       }
//                     }}
//                     onMouseOut={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow = "none";
//                     }}
//                   >
//                     <span className="text-lg">
//                       {isValidating ? 'Validating...' : 'Show Batch'}
//                     </span>
//                     <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
//                   </button>
//                 </div>

//                 {/* Info Text */}
//                 {batchName.trim() && validationStatus === 'valid' && (
//                   <div
//                     className={`${FONTS.body} mt-6 p-4 rounded-lg text-sm text-center`}
//                     style={{
//                       backgroundColor: COLORS.green2 + "20",
//                       color: COLORS.green,
//                     }}
//                   >
//                     Ready to view: <strong>{batchName.trim()}</strong>
//                   </div>
//                 )}

//                 {/* Helper Text */}
//                 <div
//                   className={`${FONTS.body} mt-6 text-center text-xs`}
//                   style={{ color: COLORS.green2 }}
//                 >
//                   Enter the exact name of the batch you want to view. The system will verify if it exists and contains images.
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>

//       {/* Animation styles */}
//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s forwards;
//         }

//         h1,
//         h2,
//         h3 {
//           letter-spacing: -0.025em;
//         }

//         p {
//           letter-spacing: 0.015em;
//         }

//         input::placeholder {
//           color: ${COLORS.green2}80;
//         }

//         input:focus {
//           outline: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WelcomeMessage;


// THIS IS AN OPTIONAL ENHANCEMENT
// Shows exact image count while keeping fast validation


// import React, { useState, useEffect } from "react";
// import { ChevronRight, Search, AlertCircle, CheckCircle } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import { useAuth } from "../AuthContext";
// import logo from "../Images/ACTIGEN.jpg";
// import config from "./Config/config";

// const COLORS = {
//   green: "#221b8dff",
//   green2: "#9aa390ff",
//   white: "#FAFAFA",
// };

// const FONTS = {
//   heading: "font-plus-jakarta-sans font-bold tracking-tight",
//   subheading: "font-plus-jakarta-sans font-semibold",
//   body: "font-plus-jakarta-sans font-normal",
//   button: "font-plus-jakarta-sans font-medium",
// };

// const WelcomeMessage = () => {
//   const [isLoaded, setIsLoaded] = useState(false);
//   const [batchName, setBatchName] = useState("");
//   const [validationStatus, setValidationStatus] = useState(null); // null, 'validating', 'valid', 'invalid', 'no-images'
//   const [validationMessage, setValidationMessage] = useState("");
//   const [isValidating, setIsValidating] = useState(false);
//   const [error, setError] = useState(null);
  
//   const navigate = useNavigate();
//   const { getToken, isAuthenticated, logout } = useAuth();

//   useEffect(() => {
//     if (!isAuthenticated()) {
//       navigate("/login");
//       return;
//     }

//     setTimeout(() => {
//       setIsLoaded(true);
//     }, 100);
//   }, [isAuthenticated, navigate]);

//   // Debounced validation - only validate after user stops typing
//   useEffect(() => {
//     if (!batchName.trim()) {
//       setValidationStatus(null);
//       setValidationMessage("");
//       return;
//     }

//     const debounceTimer = setTimeout(() => {
//       validateBatch(batchName.trim());
//     }, 800); // Wait 800ms after user stops typing

//     return () => clearTimeout(debounceTimer);
//   }, [batchName]);

//   const validateBatch = async (batch) => {
//     try {
//       setIsValidating(true);
//       setValidationStatus('validating');
//       setValidationMessage("Checking batch...");
//       setError(null);
      
//       const token = getToken();
      
//       // First, check if batch exists by listing images
//       const response = await fetch(
//         `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batch)}`,
//         {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         }
//       );
      
//       if (response.status === 401) {
//         logout();
//         navigate("/login");
//         return;
//       }
      
//       if (response.ok) {
//         const data = await response.json();
//         console.log("Validation Response:", data);
        
//         if (data.images && data.images.length > 0) {
//           // Batch exists and has images
//           setValidationStatus('valid');
//           setValidationMessage(`✓ Batch found with ${data.total_count} image${data.total_count !== 1 ? 's' : ''}`);
//         } else {
//           // Batch exists but no images
//           setValidationStatus('no-images');
//           setValidationMessage("Batch exists but contains no images");
//         }
//       } else if (response.status === 404) {
//         // Batch doesn't exist
//         setValidationStatus('invalid');
//         setValidationMessage("Batch not found");
//       } else {
//         // Other error
//         console.error("Failed to validate batch:", response.status);
//         setValidationStatus('invalid');
//         setValidationMessage("Error validating batch");
//       }
//     } catch (error) {
//       console.error("Error validating batch:", error);
//       setValidationStatus('invalid');
//       setValidationMessage("Error connecting to server");
//     } finally {
//       setIsValidating(false);
//     }
//   };

//   const handleShowBatch = () => {
//     if (batchName.trim() && validationStatus === 'valid') {
//       navigate(`/batch/${encodeURIComponent(batchName.trim())}`);
//     }
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter' && batchName.trim() && validationStatus === 'valid') {
//       handleShowBatch();
//     }
//   };

//   const getValidationColor = () => {
//     switch (validationStatus) {
//       case 'valid':
//         return '#10B981'; // Green
//       case 'invalid':
//       case 'no-images':
//         return '#EF4444'; // Red
//       case 'validating':
//         return '#F59E0B'; // Yellow/Orange
//       default:
//         return COLORS.green2;
//     }
//   };

//   const getValidationIcon = () => {
//     switch (validationStatus) {
//       case 'valid':
//         return <CheckCircle className="w-5 h-5 text-green-600" />;
//       case 'invalid':
//       case 'no-images':
//         return <AlertCircle className="w-5 h-5 text-red-600" />;
//       case 'validating':
//         return <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-yellow-600"></div>;
//       default:
//         return <Search className="w-5 h-5" style={{ color: COLORS.green2 }} />;
//     }
//   };

//   return (
//     <div
//       className="flex min-h-screen relative"
//       style={{ backgroundColor: COLORS.white }}
//     >
//       <main className="flex-1 transition-all duration-300 z-10 w-full">
//         <div className="flex flex-col p-8 min-h-screen justify-center items-center">
//           {/* Hero Content */}
//           <div className="text-center max-w-2xl mb-12">
//             <div
//               className={`transition-all duration-700 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100"
//                   : "translate-y-10 opacity-0"
//               }`}
//             >
//               <span
//                 className={`${FONTS.button} inline-block px-3 py-1 rounded-full text-sm font-medium mb-4`}
//                 style={{ backgroundColor: COLORS.green2, color: "black" }}
//               >
//                 Innovative AI Solutions
//               </span>
//               <h1
//                 className={`${FONTS.heading} text-4xl md:text-6xl mb-6 leading-tight`}
//                 style={{ color: COLORS.green }}
//               >
//                 Image Viewer
//               </h1>
//               <p
//                 className={`${FONTS.body} text-xl mb-8 mx-auto leading-relaxed`}
//                 style={{ color: COLORS.green }}
//               >
//                 Enter a batch name to begin viewing your document collection
//               </p>
//             </div>
//           </div>

//           {/* Batch Selection Card */}
//           <div className="w-full max-w-2xl">
//             <div
//               className={`relative z-10 transition-all duration-1000 delay-500 transform ${
//                 isLoaded
//                   ? "translate-y-0 opacity-100 rotate-0"
//                   : "translate-y-20 opacity-0 rotate-3"
//               }`}
//             >
//               <div
//                 className="rounded-2xl shadow-xl p-8 border overflow-hidden relative"
//                 style={{
//                   backgroundColor: COLORS.white,
//                   borderColor: COLORS.green2,
//                   boxShadow: `0 20px 25px -5px ${COLORS.green2}30, 0 10px 10px -5px ${COLORS.green2}20`,
//                 }}
//               >
//                 <h2
//                   className={`${FONTS.subheading} text-2xl font-bold mb-6 text-center`}
//                   style={{ color: COLORS.green }}
//                 >
//                   Batch Selection
//                 </h2>

//                 {error && (
//                   <div
//                     className="mb-4 p-3 rounded-lg text-sm text-center"
//                     style={{
//                       backgroundColor: "#FEE2E2",
//                       color: "#991B1B",
//                     }}
//                   >
//                     {error}
//                   </div>
//                 )}

//                 <div className="space-y-6">
//                   <div>
//                     <label
//                       className={`${FONTS.body} block mb-3 text-sm font-medium`}
//                       style={{ color: COLORS.green }}
//                     >
//                       Enter batch name
//                     </label>

//                     {/* Search Input */}
//                     <div className="relative">
//                       <input
//                         type="text"
//                         value={batchName}
//                         onChange={(e) => setBatchName(e.target.value)}
//                         onKeyPress={handleKeyPress}
//                         placeholder="Type batch name..."
//                         className={`${FONTS.body} w-full px-4 py-4 pr-12 rounded-lg border transition-all duration-300 focus:outline-none`}
//                         style={{
//                           borderColor: getValidationColor(),
//                           backgroundColor: COLORS.white,
//                           color: COLORS.green,
//                           boxShadow: validationStatus ? `0 0 0 3px ${getValidationColor()}20` : 'none',
//                         }}
//                       />
                      
//                       {/* Icon inside input */}
//                       <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
//                         {getValidationIcon()}
//                       </div>
//                     </div>

//                     {/* Validation Message */}
//                     {validationMessage && (
//                       <div
//                         className={`${FONTS.body} mt-2 p-3 rounded-lg text-sm transition-all duration-300`}
//                         style={{
//                           backgroundColor: `${getValidationColor()}15`,
//                           color: getValidationColor(),
//                           border: `1px solid ${getValidationColor()}30`,
//                         }}
//                       >
//                         {validationMessage}
//                       </div>
//                     )}
//                   </div>

//                   {/* Show Batch Button */}
//                   <button
//                     onClick={handleShowBatch}
//                     disabled={!batchName.trim() || validationStatus !== 'valid' || isValidating}
//                     className={`${FONTS.button} w-full py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed`}
//                     style={{
//                       backgroundColor:
//                         batchName.trim() && validationStatus === 'valid' && !isValidating
//                           ? COLORS.green
//                           : COLORS.green2,
//                       color: COLORS.white,
//                     }}
//                     onMouseOver={(e) => {
//                       if (batchName.trim() && validationStatus === 'valid' && !isValidating) {
//                         e.currentTarget.style.transform = "translateY(-2px)";
//                         e.currentTarget.style.boxShadow = `0 10px 20px -5px ${COLORS.green}40`;
//                       }
//                     }}
//                     onMouseOut={(e) => {
//                       e.currentTarget.style.transform = "translateY(0)";
//                       e.currentTarget.style.boxShadow = "none";
//                     }}
//                   >
//                     <span className="text-lg">
//                       {isValidating ? 'Validating...' : 'Show Batch'}
//                     </span>
//                     <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
//                   </button>
//                 </div>

//                 {/* Info Text */}
//                 {batchName.trim() && validationStatus === 'valid' && (
//                   <div
//                     className={`${FONTS.body} mt-6 p-4 rounded-lg text-sm text-center`}
//                     style={{
//                       backgroundColor: COLORS.green2 + "20",
//                       color: COLORS.green,
//                     }}
//                   >
//                     Ready to view: <strong>{batchName.trim()}</strong>
//                   </div>
//                 )}

//                 {/* Helper Text */}
//                 <div
//                   className={`${FONTS.body} mt-6 text-center text-xs`}
//                   style={{ color: COLORS.green2 }}
//                 >
//                   Enter the exact name of the batch you want to view. The system will verify if it exists and contains images.
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>

//       {/* Animation styles */}
//       <style jsx>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 0.8s forwards;
//         }

//         h1,
//         h2,
//         h3 {
//           letter-spacing: -0.025em;
//         }

//         p {
//           letter-spacing: 0.015em;
//         }

//         input::placeholder {
//           color: ${COLORS.green2}80;
//         }

//         input:focus {
//           outline: none;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default WelcomeMessage;


import React, { useState, useEffect } from "react";
import { ChevronRight, Search, AlertCircle, CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import logo from "../Images/ACTIGEN.jpg";
import config from "./Config/config";

const COLORS = {
  green: "#221b8dff",
  green2: "#9aa390ff",
  white: "#FAFAFA",
};

const FONTS = {
  heading: "font-plus-jakarta-sans font-bold tracking-tight",
  subheading: "font-plus-jakarta-sans font-semibold",
  body: "font-plus-jakarta-sans font-normal",
  button: "font-plus-jakarta-sans font-medium",
};

const WelcomeMessage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [ridName, setRidName] = useState("");
  const [batchName, setBatchName] = useState("");
  const [ridValidationStatus, setRidValidationStatus] = useState(null);
  const [ridValidationMessage, setRidValidationMessage] = useState("");
  const [batchValidationStatus, setBatchValidationStatus] = useState(null);
  const [batchValidationMessage, setBatchValidationMessage] = useState("");
  const [isValidatingRid, setIsValidatingRid] = useState(false);
  const [isValidatingBatch, setIsValidatingBatch] = useState(false);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();
  const { getToken, isAuthenticated, logout } = useAuth();

  useEffect(() => {
    if (!isAuthenticated()) {
      navigate("/login");
      return;
    }

    setTimeout(() => {
      setIsLoaded(true);
    }, 100);
  }, [isAuthenticated, navigate]);

  // Debounced RID validation
  useEffect(() => {
    if (!ridName.trim()) {
      setRidValidationStatus(null);
      setRidValidationMessage("");
      // Reset batch validation when RID is cleared
      setBatchName("");
      setBatchValidationStatus(null);
      setBatchValidationMessage("");
      return;
    }

    const debounceTimer = setTimeout(() => {
      validateRid(ridName.trim());
    }, 800);

    return () => clearTimeout(debounceTimer);
  }, [ridName]);

  // Debounced batch validation (only when RID is valid)
  useEffect(() => {
    if (!batchName.trim() || ridValidationStatus !== 'valid') {
      setBatchValidationStatus(null);
      setBatchValidationMessage("");
      return;
    }

    const debounceTimer = setTimeout(() => {
      validateBatch(ridName.trim(), batchName.trim());
    }, 800);

    return () => clearTimeout(debounceTimer);
  }, [batchName, ridValidationStatus, ridName]);

const validateRid = async (rid) => {
  try {
    setIsValidatingRid(true);
    setRidValidationStatus('validating');
    setRidValidationMessage("Checking RID...");
    setError(null);
    
    const token = getToken();
    
    const response = await fetch(
      `${config.API_BASE_URL}/api/batch_viewer/validate_rid/?rid_name=${encodeURIComponent(rid)}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    );
    
    if (response.status === 401) {
      logout();
      navigate("/login");
      return;
    }
    
    if (response.ok) {
      const data = await response.json();
      console.log("RID Validation Response:", data);
      
      if (data.exists && data.has_batches) {
        setRidValidationStatus('valid');
        // Display message from backend
        setRidValidationMessage(`✓ ${data.message}`);
      } else if (data.exists && !data.has_batches) {
        setRidValidationStatus('no-batches');
        setRidValidationMessage(data.message || "RID exists but contains no batches");
      } else {
        setRidValidationStatus('invalid');
        setRidValidationMessage(data.message || "RID not found");
      }
    } else {
      setRidValidationStatus('invalid');
      setRidValidationMessage("Error validating RID");
    }
  } catch (error) {
    console.error("Error validating RID:", error);
    setRidValidationStatus('invalid');
    setRidValidationMessage("Error connecting to server");
  } finally {
    setIsValidatingRid(false);
  }
};

  const validateBatch = async (rid, batch) => {
    try {
      setIsValidatingBatch(true);
      setBatchValidationStatus('validating');
      setBatchValidationMessage("Checking batch...");
      setError(null);
      
      const token = getToken();
      
      const response = await fetch(
        `${config.API_BASE_URL}/api/batch_viewer/list_images/?batch_name=${encodeURIComponent(batch)}&rid_name=${encodeURIComponent(rid)}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      if (response.status === 401) {
        logout();
        navigate("/login");
        return;
      }
      
      if (response.ok) {
        const data = await response.json();
        console.log("Batch Validation Response:", data);
        
        if (data.images && data.images.length > 0) {
          setBatchValidationStatus('valid');
          setBatchValidationMessage(`✓ Batch found with ${data.total_count} image${data.total_count !== 1 ? 's' : ''}`);
        } else {
          setBatchValidationStatus('no-images');
          setBatchValidationMessage("Batch exists but contains no images");
        }
      } else if (response.status === 404) {
        setBatchValidationStatus('invalid');
        setBatchValidationMessage("Batch not found");
      } else {
        setBatchValidationStatus('invalid');
        setBatchValidationMessage("Error validating batch");
      }
    } catch (error) {
      console.error("Error validating batch:", error);
      setBatchValidationStatus('invalid');
      setBatchValidationMessage("Error connecting to server");
    } finally {
      setIsValidatingBatch(false);
    }
  };

  const handleShowBatch = () => {
    if (ridName.trim() && batchName.trim() && 
        ridValidationStatus === 'valid' && batchValidationStatus === 'valid') {
      navigate(`/batch/${encodeURIComponent(ridName.trim())}/${encodeURIComponent(batchName.trim())}`);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && ridName.trim() && batchName.trim() && 
        ridValidationStatus === 'valid' && batchValidationStatus === 'valid') {
      handleShowBatch();
    }
  };

  const getRidValidationColor = () => {
    switch (ridValidationStatus) {
      case 'valid':
        return '#10B981';
      case 'invalid':
      case 'no-batches':
        return '#EF4444';
      case 'validating':
        return '#F59E0B';
      default:
        return COLORS.green2;
    }
  };

  const getBatchValidationColor = () => {
    switch (batchValidationStatus) {
      case 'valid':
        return '#10B981';
      case 'invalid':
      case 'no-images':
        return '#EF4444';
      case 'validating':
        return '#F59E0B';
      default:
        return COLORS.green2;
    }
  };

  const getValidationIcon = (status) => {
    switch (status) {
      case 'valid':
        return <CheckCircle className="w-5 h-5 text-green-600" />;
      case 'invalid':
      case 'no-images':
      case 'no-batches':
        return <AlertCircle className="w-5 h-5 text-red-600" />;
      case 'validating':
        return <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-yellow-600"></div>;
      default:
        return <Search className="w-5 h-5" style={{ color: COLORS.green2 }} />;
    }
  };

  const isReadyToView = ridName.trim() && batchName.trim() && 
                        ridValidationStatus === 'valid' && batchValidationStatus === 'valid' && 
                        !isValidatingRid && !isValidatingBatch;

  return (
    <div
      className="flex min-h-screen relative"
      style={{ backgroundColor: COLORS.white }}
    >
      <main className="flex-1 transition-all duration-300 z-10 w-full">
        <div className="flex flex-col p-8 min-h-screen justify-center items-center">
          <div className="text-center max-w-2xl mb-12">
            <div
              className={`transition-all duration-700 transform ${
                isLoaded
                  ? "translate-y-0 opacity-100"
                  : "translate-y-10 opacity-0"
              }`}
            >
              <span
                className={`${FONTS.button} inline-block px-3 py-1 rounded-full text-sm font-medium mb-4`}
                style={{ backgroundColor: COLORS.green2, color: "black" }}
              >
                Innovative AI Solutions
              </span>
              <h1
                className={`${FONTS.heading} text-4xl md:text-6xl mb-6 leading-tight`}
                style={{ color: COLORS.green }}
              >
                Image Viewer
              </h1>
              <p
                className={`${FONTS.body} text-xl mb-8 mx-auto leading-relaxed`}
                style={{ color: COLORS.green }}
              >
                Enter RID and batch name to begin viewing your document collection
              </p>
            </div>
          </div>

          <div className="w-full max-w-2xl">
            <div
              className={`relative z-10 transition-all duration-1000 delay-500 transform ${
                isLoaded
                  ? "translate-y-0 opacity-100 rotate-0"
                  : "translate-y-20 opacity-0 rotate-3"
              }`}
            >
              <div
                className="rounded-2xl shadow-xl p-8 border overflow-hidden relative"
                style={{
                  backgroundColor: COLORS.white,
                  borderColor: COLORS.green2,
                  boxShadow: `0 20px 25px -5px ${COLORS.green2}30, 0 10px 10px -5px ${COLORS.green2}20`,
                }}
              >
                <h2
                  className={`${FONTS.subheading} text-2xl font-bold mb-6 text-center`}
                  style={{ color: COLORS.green }}
                >
                  RID & Batch Selection
                </h2>

                {error && (
                  <div
                    className="mb-4 p-3 rounded-lg text-sm text-center"
                    style={{
                      backgroundColor: "#FEE2E2",
                      color: "#991B1B",
                    }}
                  >
                    {error}
                  </div>
                )}

                <div className="space-y-6">
                  {/* RID Input */}
                  <div>
                    <label
                      className={`${FONTS.body} block mb-3 text-sm font-medium`}
                      style={{ color: COLORS.green }}
                    >
                      Enter RID name
                    </label>

                    <div className="relative">
                      <input
                        type="text"
                        value={ridName}
                        onChange={(e) => setRidName(e.target.value)}
                        placeholder="Type RID name."
                        className={`${FONTS.body} w-full px-4 py-4 pr-12 rounded-lg border transition-all duration-300 focus:outline-none`}
                        style={{
                          borderColor: getRidValidationColor(),
                          backgroundColor: COLORS.white,
                          color: COLORS.green,
                          boxShadow: ridValidationStatus ? `0 0 0 3px ${getRidValidationColor()}20` : 'none',
                        }}
                      />
                      
                      <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                        {getValidationIcon(ridValidationStatus)}
                      </div>
                    </div>

                    {ridValidationMessage && (
                      <div
                        className={`${FONTS.body} mt-2 p-3 rounded-lg text-sm transition-all duration-300`}
                        style={{
                          backgroundColor: `${getRidValidationColor()}15`,
                          color: getRidValidationColor(),
                          border: `1px solid ${getRidValidationColor()}30`,
                        }}
                      >
                        {ridValidationMessage}
                      </div>
                    )}
                  </div>

                  {/* Batch Input - Only enabled when RID is valid */}
                  <div>
                    <label
                      className={`${FONTS.body} block mb-3 text-sm font-medium ${
                        ridValidationStatus !== 'valid' ? 'opacity-50' : ''
                      }`}
                      style={{ color: COLORS.green }}
                    >
                      Enter batch name
                    </label>

                    <div className="relative">
                      <input
                        type="text"
                        value={batchName}
                        onChange={(e) => setBatchName(e.target.value)}
                        onKeyPress={handleKeyPress}
                        placeholder={ridValidationStatus === 'valid' ? "Type batch name" : "Select a valid RID first"}
                        disabled={ridValidationStatus !== 'valid'}
                        className={`${FONTS.body} w-full px-4 py-4 pr-12 rounded-lg border transition-all duration-300 focus:outline-none ${
                          ridValidationStatus !== 'valid' ? 'cursor-not-allowed opacity-50' : ''
                        }`}
                        style={{
                          borderColor: ridValidationStatus === 'valid' ? getBatchValidationColor() : COLORS.green2,
                          backgroundColor: COLORS.white,
                          color: COLORS.green,
                          boxShadow: batchValidationStatus ? `0 0 0 3px ${getBatchValidationColor()}20` : 'none',
                        }}
                      />
                      
                      <div className="absolute right-4 top-1/2 transform -translate-y-1/2">
                        {ridValidationStatus === 'valid' ? getValidationIcon(batchValidationStatus) : null}
                      </div>
                    </div>

                    {batchValidationMessage && ridValidationStatus === 'valid' && (
                      <div
                        className={`${FONTS.body} mt-2 p-3 rounded-lg text-sm transition-all duration-300`}
                        style={{
                          backgroundColor: `${getBatchValidationColor()}15`,
                          color: getBatchValidationColor(),
                          border: `1px solid ${getBatchValidationColor()}30`,
                        }}
                      >
                        {batchValidationMessage}
                      </div>
                    )}
                  </div>

                  {/* Show Batch Button */}
                  <button
                    onClick={handleShowBatch}
                    disabled={!isReadyToView}
                    className={`${FONTS.button} w-full py-4 px-6 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 group disabled:opacity-50 disabled:cursor-not-allowed`}
                    style={{
                      backgroundColor: isReadyToView ? COLORS.green : COLORS.green2,
                      color: COLORS.white,
                    }}
                    onMouseOver={(e) => {
                      if (isReadyToView) {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = `0 10px 20px -5px ${COLORS.green}40`;
                      }
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <span className="text-lg">
                      {isValidatingRid || isValidatingBatch ? 'Validating...' : 'Show Batch'}
                    </span>
                    <ChevronRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                  </button>
                </div>

                {/* Info Text */}
                {isReadyToView && (
                  <div
                    className={`${FONTS.body} mt-6 p-4 rounded-lg text-sm text-center`}
                    style={{
                      backgroundColor: COLORS.green2 + "20",
                      color: COLORS.green,
                    }}
                  >
                    Ready to view: <strong>{ridName.trim()}</strong> / <strong>{batchName.trim()}</strong>
                  </div>
                )}

                {/* Helper Text */}
                <div
                  className={`${FONTS.body} mt-6 text-center text-xs`}
                  style={{ color: COLORS.green2 }}
                >
                  Enter the RID name first, then type the batch name. The system will verify both exist and contain images.
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.8s forwards;
        }

        h1, h2, h3 {
          letter-spacing: -0.025em;
        }

        p {
          letter-spacing: 0.015em;
        }

        input::placeholder {
          color: ${COLORS.green2}80;
        }

        input:focus {
          outline: none;
        }
      `}</style>
    </div>
  );
};

export default WelcomeMessage;